import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  matchPath,
  Routes,
  Route,
} from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";

// constants
import routes from "../routes";
import LocalStrings from "@language";
import {
  CDN_BASE_IMAGES_URL,
  STATIC_FAV_ICON,
  LOCAL_STORAGE_ACCESS_KEYS,
  ALLOWED_LAYOUTS,
} from "@constant";
import { REVIEWER_LOCALSTORAGE_STRUCTURE } from "@reviewerconstant";
import { loadFromLocalDB, setInLocalDB } from "../reducers/localstorage";

// components
import FourZeroFour from "../../src/components/common/pagenotfound";

const ReviewerLayout = (props) => {
  const { session, eventData, incorrectEvent = false } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const [isInvalidURL, setIsInvalidURL] = useState(false);

  useEffect(() => {
    // General redirection
    if (location.pathname === "/") navigate("/register");

    // setting dynamic event logo and name index.html head
    handleAppInit();

    // Checking for reviewer login bia localstorage
    handleLoginCheck();
  }, [eventData, session]);

  const handleAppInit = () => {
    let eventLogo = STATIC_FAV_ICON;

    let validPath = routes.filter((route) => {
      return matchPath(route.path, location.pathname);
    });

    if (!incorrectEvent && eventData?.eventicon) {
      if (validPath?.length === 0) {
        document.title = LocalStrings.kNoPage;
        setIsInvalidURL(true);
      } else {
        eventLogo = `${CDN_BASE_IMAGES_URL}/${eventData?.eventicon}`;
        document.title = `${eventData?.eventname} | Abstract Management`;
      }
    } else if (incorrectEvent) {
      document.title = LocalStrings.kNoPage;
      setIsInvalidURL(true);
    }

    const link = document.createElement("link");
    link.rel = "icon";
    link.href = eventLogo;
    link.id = "favicon";
    document.head.appendChild(link);
  };

  const handleLoginCheck = () => {
    const localReviewer = loadFromLocalDB(LOCAL_STORAGE_ACCESS_KEYS.reviewer);
    if (_.isEmpty(localReviewer)) {
      setInLocalDB({
        key: LOCAL_STORAGE_ACCESS_KEYS.reviewer,
        value: _.cloneDeep(REVIEWER_LOCALSTORAGE_STRUCTURE),
      });
      navigate("/reviewer/login");
    } else {
      if (
        localReviewer?.isLoggedIn ||
        !_.isEmpty(localReviewer?.sessionToken)
      ) {
        navigate("/reviewer");
      } else navigate("/reviewer/login");
    }
  };

  const handleRoutePreparation = () => {
    return routes.map((prop, key) => {
      if (_.isEqual(prop.layout, ALLOWED_LAYOUTS.reviewer)) {
        return (
          <Route
            path={_.replace(prop.path, "/reviewer", "")}
            element={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      {isInvalidURL ? (
        <FourZeroFour />
      ) : (
        <main className="h-full">
          <Routes>{handleRoutePreparation()}</Routes>
        </main>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.sessionReviewer,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReviewerLayout);
